var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopyCircled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16.7578,
    r: 16,
    fill: "#EDF0F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 24.7578H9V11.7578C9 11.2078 8.55 10.7578 8 10.7578C7.45 10.7578 7 11.2078 7 11.7578V24.7578C7 25.8578 7.9 26.7578 9 26.7578H19C19.55 26.7578 20 26.3078 20 25.7578C20 25.2078 19.55 24.7578 19 24.7578ZM24 20.7578V8.75781C24 7.65781 23.1 6.75781 22 6.75781H13C11.9 6.75781 11 7.65781 11 8.75781V20.7578C11 21.8578 11.9 22.7578 13 22.7578H22C23.1 22.7578 24 21.8578 24 20.7578ZM22 20.7578H13V8.75781H22V20.7578Z",
    fill: "#646471"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyCircled);
export default __webpack_public_path__ + "static/media/copy-circled.b9fcdfbd07f88a69c405ed702b7082b9.svg";
export { ForwardRef as ReactComponent };